// extracted by mini-css-extract-plugin
module.exports = {"comp":"CardInfoBtn_comp__sadTz","ef-box":"CardInfoBtn_ef-box__O8seN"};